// This file is automatically generated from Rails routes.
// DO NOT modify it manually.
// To regenerate, run: bin/rake gitlab:js:routes

import { __jsr } from '~/lib/utils/path_helpers/core';
import { hasOrganizationScopedPaths } from '~/lib/utils/path_helpers/utils';


/**
 * Generates the Rails route:
 *
 * - href: `/groups/*id/-/edit(.:format)`
 * - Path helper: `edit_group_path`
 * - URL helper: `edit_group_url`
 * - controller#action: `groups#edit`
 *
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editGroupPath = /*#__PURE__*/ (...args) => {
  const _organizationEditGroupPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _editGroupPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationEditGroupPath(gon.current_organization.path, ...args);
  }

  return _editGroupPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*id/-/issues(.:format)`
 * - Path helper: `issues_group_calendar_path`
 * - URL helper: `issues_group_calendar_url`
 * - controller#action: `groups#issues_calendar`
 *
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const issuesGroupCalendarPath = /*#__PURE__*/ (...args) => {
  const _organizationIssuesGroupCalendarPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"issues"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _issuesGroupCalendarPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"issues"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationIssuesGroupCalendarPath(gon.current_organization.path, ...args);
  }

  return _issuesGroupCalendarPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*id/-/issues(.:format)`
 * - Path helper: `issues_group_path`
 * - URL helper: `issues_group_url`
 * - controller#action: `groups#issues`
 *
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const issuesGroupPath = /*#__PURE__*/ (...args) => {
  const _organizationIssuesGroupPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"issues"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _issuesGroupPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"issues"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationIssuesGroupPath(gon.current_organization.path, ...args);
  }

  return _issuesGroupPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*id/-/merge_requests(.:format)`
 * - Path helper: `merge_requests_group_path`
 * - URL helper: `merge_requests_group_url`
 * - controller#action: `groups#merge_requests`
 *
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mergeRequestsGroupPath = /*#__PURE__*/ (...args) => {
  const _organizationMergeRequestsGroupPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _mergeRequestsGroupPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"merge_requests"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationMergeRequestsGroupPath(gon.current_organization.path, ...args);
  }

  return _mergeRequestsGroupPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*id/-/details(.:format)`
 * - Path helper: `details_group_path`
 * - URL helper: `details_group_url`
 * - controller#action: `groups#details`
 *
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const detailsGroupPath = /*#__PURE__*/ (...args) => {
  const _organizationDetailsGroupPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"details"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _detailsGroupPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"details"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationDetailsGroupPath(gon.current_organization.path, ...args);
  }

  return _detailsGroupPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*id/-/activity(.:format)`
 * - Path helper: `activity_group_path`
 * - URL helper: `activity_group_url`
 * - controller#action: `groups#activity`
 *
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const activityGroupPath = /*#__PURE__*/ (...args) => {
  const _organizationActivityGroupPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"activity"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _activityGroupPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"activity"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationActivityGroupPath(gon.current_organization.path, ...args);
  }

  return _activityGroupPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*id/-/transfer(.:format)`
 * - Path helper: `transfer_group_path`
 * - URL helper: `transfer_group_url`
 * - controller#action: `groups#transfer`
 *
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const transferGroupPath = /*#__PURE__*/ (...args) => {
  const _organizationTransferGroupPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"transfer"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _transferGroupPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"transfer"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationTransferGroupPath(gon.current_organization.path, ...args);
  }

  return _transferGroupPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*id/-/export(.:format)`
 * - Path helper: `export_group_path`
 * - URL helper: `export_group_url`
 * - controller#action: `groups#export`
 *
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const exportGroupPath = /*#__PURE__*/ (...args) => {
  const _organizationExportGroupPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _exportGroupPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationExportGroupPath(gon.current_organization.path, ...args);
  }

  return _exportGroupPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*id/-/download_export(.:format)`
 * - Path helper: `download_export_group_path`
 * - URL helper: `download_export_group_url`
 * - controller#action: `groups#download_export`
 *
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const downloadExportGroupPath = /*#__PURE__*/ (...args) => {
  const _organizationDownloadExportGroupPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"download_export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _downloadExportGroupPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"download_export"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationDownloadExportGroupPath(gon.current_organization.path, ...args);
  }

  return _downloadExportGroupPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*id/-/unfoldered_environment_names(.:format)`
 * - Path helper: `unfoldered_environment_names_group_path`
 * - URL helper: `unfoldered_environment_names_group_url`
 * - controller#action: `groups#unfoldered_environment_names`
 *
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unfolderedEnvironmentNamesGroupPath = /*#__PURE__*/ (...args) => {
  const _organizationUnfolderedEnvironmentNamesGroupPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"unfoldered_environment_names"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _unfolderedEnvironmentNamesGroupPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"unfoldered_environment_names"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationUnfolderedEnvironmentNamesGroupPath(gon.current_organization.path, ...args);
  }

  return _unfolderedEnvironmentNamesGroupPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*id/-/shared(.:format)`
 * - Path helper: `group_shared_path`
 * - URL helper: `group_shared_url`
 * - controller#action: `groups#show`
 *
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupSharedPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupSharedPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"shared"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _groupSharedPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"shared"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupSharedPath(gon.current_organization.path, ...args);
  }

  return _groupSharedPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*id/-/shared_groups(.:format)`
 * - Path helper: `group_shared_groups_path`
 * - URL helper: `group_shared_groups_url`
 * - controller#action: `groups#show`
 *
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupSharedGroupsPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupSharedGroupsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"shared_groups"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _groupSharedGroupsPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"shared_groups"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupSharedGroupsPath(gon.current_organization.path, ...args);
  }

  return _groupSharedGroupsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*id/-/inactive(.:format)`
 * - Path helper: `group_inactive_path`
 * - URL helper: `group_inactive_url`
 * - controller#action: `groups#show`
 *
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupInactivePath = /*#__PURE__*/ (...args) => {
  const _organizationGroupInactivePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"inactive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _groupInactivePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"inactive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupInactivePath(gon.current_organization.path, ...args);
  }

  return _groupInactivePath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*id/-/archived(.:format)`
 * - Path helper: `archived_path`
 * - URL helper: `archived_url`
 *
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const archivedPath = /*#__PURE__*/ (...args) => {
  const _organizationArchivedPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"archived"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _archivedPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"archived"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationArchivedPath(gon.current_organization.path, ...args);
  }

  return _archivedPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*id(.:format)`
 * - Path helper: `group_canonical_path`
 * - URL helper: `group_canonical_url`
 * - controller#action: `groups#show`
 *
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupCanonicalPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupCanonicalPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"id"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _groupCanonicalPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"id"]],[1,[2,[8,"."],[3,"format"]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupCanonicalPath(gon.current_organization.path, ...args);
  }

  return _groupCanonicalPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*id(.:format)`
 * - Path helper: `destroy_group_canonical_path`
 * - URL helper: `destroy_group_canonical_url`
 * - controller#action: `groups#destroy`
 *
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroyGroupCanonicalPath = /*#__PURE__*/ (...args) => {
  const _organizationDestroyGroupCanonicalPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"id"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);
  const _destroyGroupCanonicalPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"id"]],[1,[2,[8,"."],[3,"format"]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationDestroyGroupCanonicalPath(gon.current_organization.path, ...args);
  }

  return _destroyGroupCanonicalPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/work_items(.:format)`
 * - Path helper: `group_work_items_path`
 * - URL helper: `group_work_items_url`
 * - controller#action: `groups/work_items#rss`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupWorkItemsPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupWorkItemsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"work_items"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _groupWorkItemsPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"work_items"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupWorkItemsPath(gon.current_organization.path, ...args);
  }

  return _groupWorkItemsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/work_items/views/:id(.:format)`
 * - Path helper: `group_saved_view_path`
 * - URL helper: `group_saved_view_url`
 * - controller#action: `groups/saved_views#show`
 *
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupSavedViewPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupSavedViewPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"work_items"],[2,[7,"/"],[2,[6,"views"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _groupSavedViewPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"work_items"],[2,[7,"/"],[2,[6,"views"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupSavedViewPath(gon.current_organization.path, ...args);
  }

  return _groupSavedViewPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/settings/merge_requests(.:format)`
 * - Path helper: `group_settings_merge_requests_path`
 * - URL helper: `group_settings_merge_requests_url`
 * - controller#action: `groups/settings/merge_requests#update`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupSettingsMergeRequestsPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupSettingsMergeRequestsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"merge_requests"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupSettingsMergeRequestsPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"merge_requests"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupSettingsMergeRequestsPath(gon.current_organization.path, ...args);
  }

  return _groupSettingsMergeRequestsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/settings/ci_cd/reset_registration_token(.:format)`
 * - Path helper: `reset_registration_token_group_settings_ci_cd_path`
 * - URL helper: `reset_registration_token_group_settings_ci_cd_url`
 * - controller#action: `groups/settings/ci_cd#reset_registration_token`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resetRegistrationTokenGroupSettingsCiCdPath = /*#__PURE__*/ (...args) => {
  const _resetRegistrationTokenOrganizationGroupSettingsCiCdPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"ci_cd"],[2,[7,"/"],[2,[6,"reset_registration_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _resetRegistrationTokenGroupSettingsCiCdPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"ci_cd"],[2,[7,"/"],[2,[6,"reset_registration_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _resetRegistrationTokenOrganizationGroupSettingsCiCdPath(gon.current_organization.path, ...args);
  }

  return _resetRegistrationTokenGroupSettingsCiCdPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/settings/ci_cd/update_auto_devops(.:format)`
 * - Path helper: `update_auto_devops_group_settings_ci_cd_path`
 * - URL helper: `update_auto_devops_group_settings_ci_cd_url`
 * - controller#action: `groups/settings/ci_cd#update_auto_devops`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateAutoDevopsGroupSettingsCiCdPath = /*#__PURE__*/ (...args) => {
  const _updateAutoDevopsOrganizationGroupSettingsCiCdPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"ci_cd"],[2,[7,"/"],[2,[6,"update_auto_devops"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _updateAutoDevopsGroupSettingsCiCdPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"ci_cd"],[2,[7,"/"],[2,[6,"update_auto_devops"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _updateAutoDevopsOrganizationGroupSettingsCiCdPath(gon.current_organization.path, ...args);
  }

  return _updateAutoDevopsGroupSettingsCiCdPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/settings/ci_cd/deploy_token/create(.:format)`
 * - Path helper: `create_deploy_token_group_settings_ci_cd_path`
 * - URL helper: `create_deploy_token_group_settings_ci_cd_url`
 * - controller#action: `groups/settings/repository#create_deploy_token`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createDeployTokenGroupSettingsCiCdPath = /*#__PURE__*/ (...args) => {
  const _createDeployTokenOrganizationGroupSettingsCiCdPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"ci_cd"],[2,[7,"/"],[2,[6,"deploy_token"],[2,[7,"/"],[2,[6,"create"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);
  const _createDeployTokenGroupSettingsCiCdPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"ci_cd"],[2,[7,"/"],[2,[6,"deploy_token"],[2,[7,"/"],[2,[6,"create"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _createDeployTokenOrganizationGroupSettingsCiCdPath(gon.current_organization.path, ...args);
  }

  return _createDeployTokenGroupSettingsCiCdPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/settings/ci_cd/runner_setup_scripts(.:format)`
 * - Path helper: `runner_setup_scripts_group_settings_ci_cd_path`
 * - URL helper: `runner_setup_scripts_group_settings_ci_cd_url`
 * - controller#action: `groups/settings/ci_cd#runner_setup_scripts`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const runnerSetupScriptsGroupSettingsCiCdPath = /*#__PURE__*/ (...args) => {
  const _runnerSetupScriptsOrganizationGroupSettingsCiCdPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"ci_cd"],[2,[7,"/"],[2,[6,"runner_setup_scripts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _runnerSetupScriptsGroupSettingsCiCdPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"ci_cd"],[2,[7,"/"],[2,[6,"runner_setup_scripts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _runnerSetupScriptsOrganizationGroupSettingsCiCdPath(gon.current_organization.path, ...args);
  }

  return _runnerSetupScriptsGroupSettingsCiCdPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/settings/ci_cd(.:format)`
 * - Path helper: `group_settings_ci_cd_path`
 * - URL helper: `group_settings_ci_cd_url`
 * - controller#action: `groups/settings/ci_cd#show`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupSettingsCiCdPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupSettingsCiCdPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"ci_cd"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupSettingsCiCdPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"ci_cd"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupSettingsCiCdPath(gon.current_organization.path, ...args);
  }

  return _groupSettingsCiCdPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/settings/issues(/*vueroute)`
 * - Path helper: `issues_group_settings_issues_path`
 * - URL helper: `issues_group_settings_issues_url`
 * - controller#action: `groups/settings/work_items#show`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const issuesGroupSettingsIssuesPath = /*#__PURE__*/ (...args) => {
  const _issuesOrganizationGroupSettingsIssuesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"vueroute":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"issues"],[1,[2,[7,"/"],[5,[3,"vueroute"]]]]]]]]]]]]]]]]]]);
  const _issuesGroupSettingsIssuesPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"vueroute":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"issues"],[1,[2,[7,"/"],[5,[3,"vueroute"]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _issuesOrganizationGroupSettingsIssuesPath(gon.current_organization.path, ...args);
  }

  return _issuesGroupSettingsIssuesPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/settings/issues/new(.:format)`
 * - Path helper: `new_group_settings_issues_path`
 * - URL helper: `new_group_settings_issues_url`
 * - controller#action: `groups/settings/issues#new`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newGroupSettingsIssuesPath = /*#__PURE__*/ (...args) => {
  const _newOrganizationGroupSettingsIssuesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"issues"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _newGroupSettingsIssuesPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"issues"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _newOrganizationGroupSettingsIssuesPath(gon.current_organization.path, ...args);
  }

  return _newGroupSettingsIssuesPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/settings/issues/edit(.:format)`
 * - Path helper: `edit_group_settings_issues_path`
 * - URL helper: `edit_group_settings_issues_url`
 * - controller#action: `groups/settings/issues#edit`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editGroupSettingsIssuesPath = /*#__PURE__*/ (...args) => {
  const _editOrganizationGroupSettingsIssuesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"issues"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _editGroupSettingsIssuesPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"issues"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _editOrganizationGroupSettingsIssuesPath(gon.current_organization.path, ...args);
  }

  return _editGroupSettingsIssuesPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/settings/repository/deploy_token/create(.:format)`
 * - Path helper: `create_deploy_token_group_settings_repository_path`
 * - URL helper: `create_deploy_token_group_settings_repository_url`
 * - controller#action: `groups/settings/repository#create_deploy_token`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createDeployTokenGroupSettingsRepositoryPath = /*#__PURE__*/ (...args) => {
  const _createDeployTokenOrganizationGroupSettingsRepositoryPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"repository"],[2,[7,"/"],[2,[6,"deploy_token"],[2,[7,"/"],[2,[6,"create"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);
  const _createDeployTokenGroupSettingsRepositoryPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"repository"],[2,[7,"/"],[2,[6,"deploy_token"],[2,[7,"/"],[2,[6,"create"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _createDeployTokenOrganizationGroupSettingsRepositoryPath(gon.current_organization.path, ...args);
  }

  return _createDeployTokenGroupSettingsRepositoryPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/settings/repository(.:format)`
 * - Path helper: `group_settings_repository_path`
 * - URL helper: `group_settings_repository_url`
 * - controller#action: `groups/settings/repository#show`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupSettingsRepositoryPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupSettingsRepositoryPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"repository"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupSettingsRepositoryPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"repository"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupSettingsRepositoryPath(gon.current_organization.path, ...args);
  }

  return _groupSettingsRepositoryPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/settings/service_accounts(/*vueroute)(.:format)`
 * - Path helper: `group_settings_service_accounts_path`
 * - URL helper: `group_settings_service_accounts_url`
 * - controller#action: `groups/settings/service_accounts#index`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupSettingsServiceAccountsPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupSettingsServiceAccountsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"vueroute":{},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"service_accounts"],[2,[1,[2,[7,"/"],[5,[3,"vueroute"]]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]);
  const _groupSettingsServiceAccountsPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"vueroute":{},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"service_accounts"],[2,[1,[2,[7,"/"],[5,[3,"vueroute"]]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupSettingsServiceAccountsPath(gon.current_organization.path, ...args);
  }

  return _groupSettingsServiceAccountsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/settings/access_tokens/:id/revoke(.:format)`
 * - Path helper: `revoke_group_settings_access_token_path`
 * - URL helper: `revoke_group_settings_access_token_url`
 * - controller#action: `groups/settings/access_tokens#revoke`
 *
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const revokeGroupSettingsAccessTokenPath = /*#__PURE__*/ (...args) => {
  const _revokeOrganizationGroupSettingsAccessTokenPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"access_tokens"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"revoke"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);
  const _revokeGroupSettingsAccessTokenPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"access_tokens"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"revoke"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _revokeOrganizationGroupSettingsAccessTokenPath(gon.current_organization.path, ...args);
  }

  return _revokeGroupSettingsAccessTokenPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/settings/access_tokens/:id/rotate(.:format)`
 * - Path helper: `rotate_group_settings_access_token_path`
 * - URL helper: `rotate_group_settings_access_token_url`
 * - controller#action: `groups/settings/access_tokens#rotate`
 *
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rotateGroupSettingsAccessTokenPath = /*#__PURE__*/ (...args) => {
  const _rotateOrganizationGroupSettingsAccessTokenPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"access_tokens"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"rotate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);
  const _rotateGroupSettingsAccessTokenPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"access_tokens"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"rotate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _rotateOrganizationGroupSettingsAccessTokenPath(gon.current_organization.path, ...args);
  }

  return _rotateGroupSettingsAccessTokenPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/settings/access_tokens/inactive(.:format)`
 * - Path helper: `inactive_group_settings_access_tokens_path`
 * - URL helper: `inactive_group_settings_access_tokens_url`
 * - controller#action: `groups/settings/access_tokens#inactive`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inactiveGroupSettingsAccessTokensPath = /*#__PURE__*/ (...args) => {
  const _inactiveOrganizationGroupSettingsAccessTokensPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"access_tokens"],[2,[7,"/"],[2,[6,"inactive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _inactiveGroupSettingsAccessTokensPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"access_tokens"],[2,[7,"/"],[2,[6,"inactive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _inactiveOrganizationGroupSettingsAccessTokensPath(gon.current_organization.path, ...args);
  }

  return _inactiveGroupSettingsAccessTokensPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/settings/access_tokens(.:format)`
 * - Path helper: `group_settings_access_tokens_path`
 * - URL helper: `group_settings_access_tokens_url`
 * - controller#action: `groups/settings/access_tokens#index`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupSettingsAccessTokensPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupSettingsAccessTokensPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"access_tokens"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupSettingsAccessTokensPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"access_tokens"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupSettingsAccessTokensPath(gon.current_organization.path, ...args);
  }

  return _groupSettingsAccessTokensPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/settings/integrations/:id/test(.:format)`
 * - Path helper: `test_group_settings_integration_path`
 * - URL helper: `test_group_settings_integration_url`
 * - controller#action: `groups/settings/integrations#test`
 *
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const testGroupSettingsIntegrationPath = /*#__PURE__*/ (...args) => {
  const _testOrganizationGroupSettingsIntegrationPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"test"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);
  const _testGroupSettingsIntegrationPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"test"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _testOrganizationGroupSettingsIntegrationPath(gon.current_organization.path, ...args);
  }

  return _testGroupSettingsIntegrationPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/settings/integrations/:id/reset(.:format)`
 * - Path helper: `reset_group_settings_integration_path`
 * - URL helper: `reset_group_settings_integration_url`
 * - controller#action: `groups/settings/integrations#reset`
 *
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resetGroupSettingsIntegrationPath = /*#__PURE__*/ (...args) => {
  const _resetOrganizationGroupSettingsIntegrationPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reset"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);
  const _resetGroupSettingsIntegrationPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reset"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _resetOrganizationGroupSettingsIntegrationPath(gon.current_organization.path, ...args);
  }

  return _resetGroupSettingsIntegrationPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/settings/integrations(.:format)`
 * - Path helper: `group_settings_integrations_path`
 * - URL helper: `group_settings_integrations_url`
 * - controller#action: `groups/settings/integrations#index`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupSettingsIntegrationsPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupSettingsIntegrationsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"integrations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupSettingsIntegrationsPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"integrations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupSettingsIntegrationsPath(gon.current_organization.path, ...args);
  }

  return _groupSettingsIntegrationsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/settings/integrations/:id/edit(.:format)`
 * - Path helper: `edit_group_settings_integration_path`
 * - URL helper: `edit_group_settings_integration_url`
 * - controller#action: `groups/settings/integrations#edit`
 *
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editGroupSettingsIntegrationPath = /*#__PURE__*/ (...args) => {
  const _editOrganizationGroupSettingsIntegrationPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);
  const _editGroupSettingsIntegrationPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _editOrganizationGroupSettingsIntegrationPath(gon.current_organization.path, ...args);
  }

  return _editGroupSettingsIntegrationPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/settings/integrations/:id(.:format)`
 * - Path helper: `group_settings_integration_path`
 * - URL helper: `group_settings_integration_url`
 * - controller#action: `groups/settings/integrations#update`
 *
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupSettingsIntegrationPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupSettingsIntegrationPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _groupSettingsIntegrationPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupSettingsIntegrationPath(gon.current_organization.path, ...args);
  }

  return _groupSettingsIntegrationPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/settings/slack/slack_auth(.:format)`
 * - Path helper: `slack_auth_group_settings_slack_path`
 * - URL helper: `slack_auth_group_settings_slack_url`
 * - controller#action: `groups/settings/slacks#slack_auth`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const slackAuthGroupSettingsSlackPath = /*#__PURE__*/ (...args) => {
  const _slackAuthOrganizationGroupSettingsSlackPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"slack"],[2,[7,"/"],[2,[6,"slack_auth"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _slackAuthGroupSettingsSlackPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"slack"],[2,[7,"/"],[2,[6,"slack_auth"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _slackAuthOrganizationGroupSettingsSlackPath(gon.current_organization.path, ...args);
  }

  return _slackAuthGroupSettingsSlackPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/settings/slack(.:format)`
 * - Path helper: `group_settings_slack_path`
 * - URL helper: `group_settings_slack_url`
 * - controller#action: `groups/settings/slacks#destroy`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupSettingsSlackPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupSettingsSlackPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"slack"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupSettingsSlackPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"slack"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupSettingsSlackPath(gon.current_organization.path, ...args);
  }

  return _groupSettingsSlackPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/settings/applications/:id/renew(.:format)`
 * - Path helper: `renew_group_settings_application_path`
 * - URL helper: `renew_group_settings_application_url`
 * - controller#action: `groups/settings/applications#renew`
 *
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const renewGroupSettingsApplicationPath = /*#__PURE__*/ (...args) => {
  const _renewOrganizationGroupSettingsApplicationPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"renew"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);
  const _renewGroupSettingsApplicationPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"renew"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _renewOrganizationGroupSettingsApplicationPath(gon.current_organization.path, ...args);
  }

  return _renewGroupSettingsApplicationPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/settings/applications(.:format)`
 * - Path helper: `group_settings_applications_path`
 * - URL helper: `group_settings_applications_url`
 * - controller#action: `groups/settings/applications#index`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupSettingsApplicationsPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupSettingsApplicationsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"applications"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupSettingsApplicationsPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"applications"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupSettingsApplicationsPath(gon.current_organization.path, ...args);
  }

  return _groupSettingsApplicationsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/settings/applications/new(.:format)`
 * - Path helper: `new_group_settings_application_path`
 * - URL helper: `new_group_settings_application_url`
 * - controller#action: `groups/settings/applications#new`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newGroupSettingsApplicationPath = /*#__PURE__*/ (...args) => {
  const _newOrganizationGroupSettingsApplicationPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _newGroupSettingsApplicationPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _newOrganizationGroupSettingsApplicationPath(gon.current_organization.path, ...args);
  }

  return _newGroupSettingsApplicationPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/settings/applications/:id/edit(.:format)`
 * - Path helper: `edit_group_settings_application_path`
 * - URL helper: `edit_group_settings_application_url`
 * - controller#action: `groups/settings/applications#edit`
 *
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editGroupSettingsApplicationPath = /*#__PURE__*/ (...args) => {
  const _editOrganizationGroupSettingsApplicationPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);
  const _editGroupSettingsApplicationPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _editOrganizationGroupSettingsApplicationPath(gon.current_organization.path, ...args);
  }

  return _editGroupSettingsApplicationPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/settings/applications/:id(.:format)`
 * - Path helper: `group_settings_application_path`
 * - URL helper: `group_settings_application_url`
 * - controller#action: `groups/settings/applications#show`
 *
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupSettingsApplicationPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupSettingsApplicationPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _groupSettingsApplicationPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupSettingsApplicationPath(gon.current_organization.path, ...args);
  }

  return _groupSettingsApplicationPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/settings/packages_and_registries(.:format)`
 * - Path helper: `group_settings_packages_and_registries_path`
 * - URL helper: `group_settings_packages_and_registries_url`
 * - controller#action: `groups/settings/packages_and_registries#show`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupSettingsPackagesAndRegistriesPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupSettingsPackagesAndRegistriesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"packages_and_registries"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupSettingsPackagesAndRegistriesPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"packages_and_registries"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupSettingsPackagesAndRegistriesPath(gon.current_organization.path, ...args);
  }

  return _groupSettingsPackagesAndRegistriesPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/variables(.:format)`
 * - Path helper: `group_variables_path`
 * - URL helper: `group_variables_url`
 * - controller#action: `groups/variables#show`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupVariablesPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupVariablesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"variables"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _groupVariablesPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"variables"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupVariablesPath(gon.current_organization.path, ...args);
  }

  return _groupVariablesPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/children(.:format)`
 * - Path helper: `group_children_path`
 * - URL helper: `group_children_url`
 * - controller#action: `groups/children#index`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupChildrenPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupChildrenPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"children"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _groupChildrenPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"children"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupChildrenPath(gon.current_organization.path, ...args);
  }

  return _groupChildrenPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/labels/:id/toggle_subscription(.:format)`
 * - Path helper: `toggle_subscription_group_label_path`
 * - URL helper: `toggle_subscription_group_label_url`
 * - controller#action: `groups/labels#toggle_subscription`
 *
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggleSubscriptionGroupLabelPath = /*#__PURE__*/ (...args) => {
  const _toggleSubscriptionOrganizationGroupLabelPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"labels"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"toggle_subscription"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _toggleSubscriptionGroupLabelPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"labels"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"toggle_subscription"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _toggleSubscriptionOrganizationGroupLabelPath(gon.current_organization.path, ...args);
  }

  return _toggleSubscriptionGroupLabelPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/labels(.:format)`
 * - Path helper: `group_labels_path`
 * - URL helper: `group_labels_url`
 * - controller#action: `groups/labels#index`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupLabelsPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupLabelsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"labels"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _groupLabelsPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"labels"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupLabelsPath(gon.current_organization.path, ...args);
  }

  return _groupLabelsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/labels/new(.:format)`
 * - Path helper: `new_group_label_path`
 * - URL helper: `new_group_label_url`
 * - controller#action: `groups/labels#new`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newGroupLabelPath = /*#__PURE__*/ (...args) => {
  const _newOrganizationGroupLabelPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"labels"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _newGroupLabelPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"labels"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _newOrganizationGroupLabelPath(gon.current_organization.path, ...args);
  }

  return _newGroupLabelPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/labels/:id/edit(.:format)`
 * - Path helper: `edit_group_label_path`
 * - URL helper: `edit_group_label_url`
 * - controller#action: `groups/labels#edit`
 *
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editGroupLabelPath = /*#__PURE__*/ (...args) => {
  const _editOrganizationGroupLabelPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"labels"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _editGroupLabelPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"labels"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _editOrganizationGroupLabelPath(gon.current_organization.path, ...args);
  }

  return _editGroupLabelPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/labels/:id(.:format)`
 * - Path helper: `group_label_path`
 * - URL helper: `group_label_url`
 * - controller#action: `groups/labels#update`
 *
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupLabelPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupLabelPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"labels"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupLabelPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"labels"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupLabelPath(gon.current_organization.path, ...args);
  }

  return _groupLabelPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/custom_emoji(.:format)`
 * - Path helper: `group_custom_emoji_index_path`
 * - URL helper: `group_custom_emoji_index_url`
 * - controller#action: `groups/custom_emoji#index`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupCustomEmojiIndexPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupCustomEmojiIndexPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"custom_emoji"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _groupCustomEmojiIndexPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"custom_emoji"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupCustomEmojiIndexPath(gon.current_organization.path, ...args);
  }

  return _groupCustomEmojiIndexPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/custom_emoji/new(.:format)`
 * - Path helper: `new_group_custom_emoji_path`
 * - URL helper: `new_group_custom_emoji_url`
 * - controller#action: `groups/custom_emoji#index`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newGroupCustomEmojiPath = /*#__PURE__*/ (...args) => {
  const _newOrganizationGroupCustomEmojiPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"custom_emoji"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _newGroupCustomEmojiPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"custom_emoji"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _newOrganizationGroupCustomEmojiPath(gon.current_organization.path, ...args);
  }

  return _newGroupCustomEmojiPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/packages(.:format)`
 * - Path helper: `group_packages_path`
 * - URL helper: `group_packages_url`
 * - controller#action: `groups/packages#index`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupPackagesPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupPackagesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"packages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _groupPackagesPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"packages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupPackagesPath(gon.current_organization.path, ...args);
  }

  return _groupPackagesPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/packages/:id(.:format)`
 * - Path helper: `group_package_path`
 * - URL helper: `group_package_url`
 * - controller#action: `groups/packages#show`
 *
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupPackagePath = /*#__PURE__*/ (...args) => {
  const _organizationGroupPackagePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"packages"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupPackagePath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"packages"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupPackagePath(gon.current_organization.path, ...args);
  }

  return _groupPackagePath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/terraform_module_registry(.:format)`
 * - Path helper: `group_infrastructure_registry_index_path`
 * - URL helper: `group_infrastructure_registry_index_url`
 * - controller#action: `groups/infrastructure_registry#index`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupInfrastructureRegistryIndexPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupInfrastructureRegistryIndexPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"terraform_module_registry"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _groupInfrastructureRegistryIndexPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"terraform_module_registry"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupInfrastructureRegistryIndexPath(gon.current_organization.path, ...args);
  }

  return _groupInfrastructureRegistryIndexPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/infrastructure_registry(.:format)`
 * - Path helper: `group_infrastructure_registry_path`
 * - URL helper: `group_infrastructure_registry_url`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupInfrastructureRegistryPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupInfrastructureRegistryPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"infrastructure_registry"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _groupInfrastructureRegistryPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"infrastructure_registry"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupInfrastructureRegistryPath(gon.current_organization.path, ...args);
  }

  return _groupInfrastructureRegistryPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/milestones/:id/issues(.:format)`
 * - Path helper: `issues_group_milestone_path`
 * - URL helper: `issues_group_milestone_url`
 * - controller#action: `groups/milestones#issues`
 *
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const issuesGroupMilestonePath = /*#__PURE__*/ (...args) => {
  const _issuesOrganizationGroupMilestonePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"milestones"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"issues"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _issuesGroupMilestonePath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"milestones"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"issues"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _issuesOrganizationGroupMilestonePath(gon.current_organization.path, ...args);
  }

  return _issuesGroupMilestonePath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/milestones/:id/merge_requests(.:format)`
 * - Path helper: `merge_requests_group_milestone_path`
 * - URL helper: `merge_requests_group_milestone_url`
 * - controller#action: `groups/milestones#merge_requests`
 *
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mergeRequestsGroupMilestonePath = /*#__PURE__*/ (...args) => {
  const _mergeRequestsOrganizationGroupMilestonePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"milestones"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"merge_requests"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _mergeRequestsGroupMilestonePath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"milestones"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"merge_requests"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _mergeRequestsOrganizationGroupMilestonePath(gon.current_organization.path, ...args);
  }

  return _mergeRequestsGroupMilestonePath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/milestones/:id/participants(.:format)`
 * - Path helper: `participants_group_milestone_path`
 * - URL helper: `participants_group_milestone_url`
 * - controller#action: `groups/milestones#participants`
 *
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const participantsGroupMilestonePath = /*#__PURE__*/ (...args) => {
  const _participantsOrganizationGroupMilestonePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"milestones"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"participants"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _participantsGroupMilestonePath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"milestones"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"participants"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _participantsOrganizationGroupMilestonePath(gon.current_organization.path, ...args);
  }

  return _participantsGroupMilestonePath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/milestones/:id/labels(.:format)`
 * - Path helper: `labels_group_milestone_path`
 * - URL helper: `labels_group_milestone_url`
 * - controller#action: `groups/milestones#labels`
 *
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const labelsGroupMilestonePath = /*#__PURE__*/ (...args) => {
  const _labelsOrganizationGroupMilestonePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"milestones"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"labels"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _labelsGroupMilestonePath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"milestones"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"labels"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _labelsOrganizationGroupMilestonePath(gon.current_organization.path, ...args);
  }

  return _labelsGroupMilestonePath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/milestones(.:format)`
 * - Path helper: `group_milestones_path`
 * - URL helper: `group_milestones_url`
 * - controller#action: `groups/milestones#index`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupMilestonesPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupMilestonesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"milestones"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _groupMilestonesPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"milestones"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupMilestonesPath(gon.current_organization.path, ...args);
  }

  return _groupMilestonesPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/milestones/new(.:format)`
 * - Path helper: `new_group_milestone_path`
 * - URL helper: `new_group_milestone_url`
 * - controller#action: `groups/milestones#new`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newGroupMilestonePath = /*#__PURE__*/ (...args) => {
  const _newOrganizationGroupMilestonePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"milestones"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _newGroupMilestonePath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"milestones"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _newOrganizationGroupMilestonePath(gon.current_organization.path, ...args);
  }

  return _newGroupMilestonePath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/milestones/:id/edit(.:format)`
 * - Path helper: `edit_group_milestone_path`
 * - URL helper: `edit_group_milestone_url`
 * - controller#action: `groups/milestones#edit`
 *
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editGroupMilestonePath = /*#__PURE__*/ (...args) => {
  const _editOrganizationGroupMilestonePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"milestones"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _editGroupMilestonePath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"milestones"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _editOrganizationGroupMilestonePath(gon.current_organization.path, ...args);
  }

  return _editGroupMilestonePath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/milestones/:id(.:format)`
 * - Path helper: `group_milestone_path`
 * - URL helper: `group_milestone_url`
 * - controller#action: `groups/milestones#show`
 *
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupMilestonePath = /*#__PURE__*/ (...args) => {
  const _organizationGroupMilestonePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"milestones"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupMilestonePath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"milestones"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupMilestonePath(gon.current_organization.path, ...args);
  }

  return _groupMilestonePath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/releases(.:format)`
 * - Path helper: `group_releases_path`
 * - URL helper: `group_releases_url`
 * - controller#action: `groups/releases#index`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupReleasesPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupReleasesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"releases"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _groupReleasesPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"releases"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupReleasesPath(gon.current_organization.path, ...args);
  }

  return _groupReleasesPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/deploy_tokens/:id/revoke(.:format)`
 * - Path helper: `revoke_group_deploy_token_path`
 * - URL helper: `revoke_group_deploy_token_url`
 * - controller#action: `groups/deploy_tokens#revoke`
 *
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const revokeGroupDeployTokenPath = /*#__PURE__*/ (...args) => {
  const _revokeOrganizationGroupDeployTokenPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"deploy_tokens"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"revoke"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _revokeGroupDeployTokenPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"deploy_tokens"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"revoke"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _revokeOrganizationGroupDeployTokenPath(gon.current_organization.path, ...args);
  }

  return _revokeGroupDeployTokenPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/avatar(.:format)`
 * - Path helper: `group_avatar_path`
 * - URL helper: `group_avatar_url`
 * - controller#action: `groups/avatars#destroy`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupAvatarPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupAvatarPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"avatar"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _groupAvatarPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"avatar"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupAvatarPath(gon.current_organization.path, ...args);
  }

  return _groupAvatarPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/import(.:format)`
 * - Path helper: `group_import_path`
 * - URL helper: `group_import_url`
 * - controller#action: `groups/imports#show`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupImportPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupImportPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"import"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _groupImportPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"import"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupImportPath(gon.current_organization.path, ...args);
  }

  return _groupImportPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/group_members/:id/resend_invite(.:format)`
 * - Path helper: `resend_invite_group_group_member_path`
 * - URL helper: `resend_invite_group_group_member_url`
 * - controller#action: `groups/group_members#resend_invite`
 *
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resendInviteGroupGroupMemberPath = /*#__PURE__*/ (...args) => {
  const _resendInviteOrganizationGroupGroupMemberPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"group_members"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"resend_invite"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _resendInviteGroupGroupMemberPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"group_members"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"resend_invite"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _resendInviteOrganizationGroupGroupMemberPath(gon.current_organization.path, ...args);
  }

  return _resendInviteGroupGroupMemberPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/group_members/bulk_reassignment_file/authorize(.:format)`
 * - Path helper: `authorize_group_bulk_reassignment_file_path`
 * - URL helper: `authorize_group_bulk_reassignment_file_url`
 * - controller#action: `groups/bulk_placeholder_assignments#authorize`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const authorizeGroupBulkReassignmentFilePath = /*#__PURE__*/ (...args) => {
  const _authorizeOrganizationGroupBulkReassignmentFilePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"group_members"],[2,[7,"/"],[2,[6,"bulk_reassignment_file"],[2,[7,"/"],[2,[6,"authorize"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _authorizeGroupBulkReassignmentFilePath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"group_members"],[2,[7,"/"],[2,[6,"bulk_reassignment_file"],[2,[7,"/"],[2,[6,"authorize"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _authorizeOrganizationGroupBulkReassignmentFilePath(gon.current_organization.path, ...args);
  }

  return _authorizeGroupBulkReassignmentFilePath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/group_members/bulk_reassignment_file(.:format)`
 * - Path helper: `group_bulk_reassignment_file_path`
 * - URL helper: `group_bulk_reassignment_file_url`
 * - controller#action: `groups/bulk_placeholder_assignments#show`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupBulkReassignmentFilePath = /*#__PURE__*/ (...args) => {
  const _organizationGroupBulkReassignmentFilePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"group_members"],[2,[7,"/"],[2,[6,"bulk_reassignment_file"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupBulkReassignmentFilePath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"group_members"],[2,[7,"/"],[2,[6,"bulk_reassignment_file"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupBulkReassignmentFilePath(gon.current_organization.path, ...args);
  }

  return _groupBulkReassignmentFilePath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/group_members/leave(.:format)`
 * - Path helper: `leave_group_group_members_path`
 * - URL helper: `leave_group_group_members_url`
 * - controller#action: `groups/group_members#leave`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const leaveGroupGroupMembersPath = /*#__PURE__*/ (...args) => {
  const _leaveOrganizationGroupGroupMembersPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"group_members"],[2,[7,"/"],[2,[6,"leave"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _leaveGroupGroupMembersPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"group_members"],[2,[7,"/"],[2,[6,"leave"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _leaveOrganizationGroupGroupMembersPath(gon.current_organization.path, ...args);
  }

  return _leaveGroupGroupMembersPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/group_members/invite_search(.:format)`
 * - Path helper: `invite_search_group_group_members_path`
 * - URL helper: `invite_search_group_group_members_url`
 * - controller#action: `groups/group_members#invite_search`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const inviteSearchGroupGroupMembersPath = /*#__PURE__*/ (...args) => {
  const _inviteSearchOrganizationGroupGroupMembersPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"group_members"],[2,[7,"/"],[2,[6,"invite_search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _inviteSearchGroupGroupMembersPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"group_members"],[2,[7,"/"],[2,[6,"invite_search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _inviteSearchOrganizationGroupGroupMembersPath(gon.current_organization.path, ...args);
  }

  return _inviteSearchGroupGroupMembersPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/group_members(.:format)`
 * - Path helper: `group_group_members_path`
 * - URL helper: `group_group_members_url`
 * - controller#action: `groups/group_members#index`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupGroupMembersPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupGroupMembersPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"group_members"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _groupGroupMembersPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"group_members"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupGroupMembersPath(gon.current_organization.path, ...args);
  }

  return _groupGroupMembersPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/group_members/:id(.:format)`
 * - Path helper: `group_group_member_path`
 * - URL helper: `group_group_member_url`
 * - controller#action: `groups/group_members#update`
 *
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupGroupMemberPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupGroupMemberPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"group_members"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupGroupMemberPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"group_members"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupGroupMemberPath(gon.current_organization.path, ...args);
  }

  return _groupGroupMemberPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/group_links/:id(.:format)`
 * - Path helper: `group_group_link_path`
 * - URL helper: `group_group_link_url`
 * - controller#action: `groups/group_links#update`
 *
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupGroupLinkPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupGroupLinkPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"group_links"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupGroupLinkPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"group_links"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupGroupLinkPath(gon.current_organization.path, ...args);
  }

  return _groupGroupLinkPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/uploads/:secret/:filename`
 * - Path helper: `show_group_uploads_path`
 * - URL helper: `show_group_uploads_url`
 * - controller#action: `groups/uploads#show`
 *
 * @param {any} groupId
 * @param {any} secret
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const showGroupUploadsPath = /*#__PURE__*/ (...args) => {
  const _showOrganizationGroupUploadsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"secret":{"r":true},"filename":{"r":true}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"uploads"],[2,[7,"/"],[2,[3,"secret"],[2,[7,"/"],[3,"filename"]]]]]]]]]]]]]]]]);
  const _showGroupUploadsPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"secret":{"r":true},"filename":{"r":true}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"uploads"],[2,[7,"/"],[2,[3,"secret"],[2,[7,"/"],[3,"filename"]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _showOrganizationGroupUploadsPath(gon.current_organization.path, ...args);
  }

  return _showGroupUploadsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/uploads/authorize(.:format)`
 * - Path helper: `authorize_group_uploads_path`
 * - URL helper: `authorize_group_uploads_url`
 * - controller#action: `groups/uploads#authorize`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const authorizeGroupUploadsPath = /*#__PURE__*/ (...args) => {
  const _authorizeOrganizationGroupUploadsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"uploads"],[2,[7,"/"],[2,[6,"authorize"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _authorizeGroupUploadsPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"uploads"],[2,[7,"/"],[2,[6,"authorize"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _authorizeOrganizationGroupUploadsPath(gon.current_organization.path, ...args);
  }

  return _authorizeGroupUploadsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/uploads(.:format)`
 * - Path helper: `group_uploads_path`
 * - URL helper: `group_uploads_url`
 * - controller#action: `groups/uploads#create`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupUploadsPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupUploadsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"uploads"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _groupUploadsPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"uploads"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupUploadsPath(gon.current_organization.path, ...args);
  }

  return _groupUploadsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/boards(.:format)`
 * - Path helper: `group_boards_path`
 * - URL helper: `group_boards_url`
 * - controller#action: `groups/boards#index`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupBoardsPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupBoardsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"boards"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _groupBoardsPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"boards"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupBoardsPath(gon.current_organization.path, ...args);
  }

  return _groupBoardsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/boards/:id(.:format)`
 * - Path helper: `group_board_path`
 * - URL helper: `group_board_url`
 * - controller#action: `groups/boards#show`
 *
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupBoardPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupBoardPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"boards"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupBoardPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"boards"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupBoardPath(gon.current_organization.path, ...args);
  }

  return _groupBoardPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/runners/:id/register(.:format)`
 * - Path helper: `register_group_runner_path`
 * - URL helper: `register_group_runner_url`
 * - controller#action: `groups/runners#register`
 *
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const registerGroupRunnerPath = /*#__PURE__*/ (...args) => {
  const _registerOrganizationGroupRunnerPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"runners"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"register"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _registerGroupRunnerPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"runners"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"register"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _registerOrganizationGroupRunnerPath(gon.current_organization.path, ...args);
  }

  return _registerGroupRunnerPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/runners/:id/resume(.:format)`
 * - Path helper: `resume_group_runner_path`
 * - URL helper: `resume_group_runner_url`
 * - controller#action: `groups/runners#resume`
 *
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resumeGroupRunnerPath = /*#__PURE__*/ (...args) => {
  const _resumeOrganizationGroupRunnerPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"runners"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"resume"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _resumeGroupRunnerPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"runners"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"resume"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _resumeOrganizationGroupRunnerPath(gon.current_organization.path, ...args);
  }

  return _resumeGroupRunnerPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/runners/:id/pause(.:format)`
 * - Path helper: `pause_group_runner_path`
 * - URL helper: `pause_group_runner_url`
 * - controller#action: `groups/runners#pause`
 *
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pauseGroupRunnerPath = /*#__PURE__*/ (...args) => {
  const _pauseOrganizationGroupRunnerPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"runners"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"pause"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _pauseGroupRunnerPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"runners"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"pause"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _pauseOrganizationGroupRunnerPath(gon.current_organization.path, ...args);
  }

  return _pauseGroupRunnerPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/runners(.:format)`
 * - Path helper: `group_runners_path`
 * - URL helper: `group_runners_url`
 * - controller#action: `groups/runners#index`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupRunnersPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupRunnersPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"runners"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _groupRunnersPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"runners"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupRunnersPath(gon.current_organization.path, ...args);
  }

  return _groupRunnersPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/runners/new(.:format)`
 * - Path helper: `new_group_runner_path`
 * - URL helper: `new_group_runner_url`
 * - controller#action: `groups/runners#new`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newGroupRunnerPath = /*#__PURE__*/ (...args) => {
  const _newOrganizationGroupRunnerPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"runners"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _newGroupRunnerPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"runners"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _newOrganizationGroupRunnerPath(gon.current_organization.path, ...args);
  }

  return _newGroupRunnerPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/runners/:id/edit(.:format)`
 * - Path helper: `edit_group_runner_path`
 * - URL helper: `edit_group_runner_url`
 * - controller#action: `groups/runners#edit`
 *
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editGroupRunnerPath = /*#__PURE__*/ (...args) => {
  const _editOrganizationGroupRunnerPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"runners"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _editGroupRunnerPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"runners"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _editOrganizationGroupRunnerPath(gon.current_organization.path, ...args);
  }

  return _editGroupRunnerPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/runners/:id(.:format)`
 * - Path helper: `group_runner_path`
 * - URL helper: `group_runner_url`
 * - controller#action: `groups/runners#show`
 *
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupRunnerPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupRunnerPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"runners"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupRunnerPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"runners"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupRunnerPath(gon.current_organization.path, ...args);
  }

  return _groupRunnerPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/container_registries(.:format)`
 * - Path helper: `group_container_registries_path`
 * - URL helper: `group_container_registries_url`
 * - controller#action: `groups/registry/repositories#index`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupContainerRegistriesPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupContainerRegistriesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"container_registries"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _groupContainerRegistriesPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"container_registries"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupContainerRegistriesPath(gon.current_organization.path, ...args);
  }

  return _groupContainerRegistriesPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/container_registries/:id(.:format)`
 * - Path helper: `group_container_registry_path`
 * - URL helper: `group_container_registry_url`
 * - controller#action: `groups/registry/repositories#show`
 *
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupContainerRegistryPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupContainerRegistryPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"container_registries"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupContainerRegistryPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"container_registries"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupContainerRegistryPath(gon.current_organization.path, ...args);
  }

  return _groupContainerRegistryPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/dependency_proxy(.:format)`
 * - Path helper: `group_dependency_proxy_path`
 * - URL helper: `group_dependency_proxy_url`
 * - controller#action: `groups/dependency_proxies#show`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupDependencyProxyPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupDependencyProxyPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"dependency_proxy"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _groupDependencyProxyPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"dependency_proxy"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupDependencyProxyPath(gon.current_organization.path, ...args);
  }

  return _groupDependencyProxyPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/harbor/repositories/:repository_id/artifacts/:artifact_id/tags(.:format)`
 * - Path helper: `group_harbor_repository_artifact_tags_path`
 * - URL helper: `group_harbor_repository_artifact_tags_url`
 * - controller#action: `groups/harbor/tags#index`
 *
 * @param {any} groupId
 * @param {any} repositoryId
 * @param {any} artifactId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupHarborRepositoryArtifactTagsPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupHarborRepositoryArtifactTagsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"repository_id":{"r":true},"artifact_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"harbor"],[2,[7,"/"],[2,[6,"repositories"],[2,[7,"/"],[2,[3,"repository_id"],[2,[7,"/"],[2,[6,"artifacts"],[2,[7,"/"],[2,[3,"artifact_id"],[2,[7,"/"],[2,[6,"tags"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]]]]]);
  const _groupHarborRepositoryArtifactTagsPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"repository_id":{"r":true},"artifact_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"harbor"],[2,[7,"/"],[2,[6,"repositories"],[2,[7,"/"],[2,[3,"repository_id"],[2,[7,"/"],[2,[6,"artifacts"],[2,[7,"/"],[2,[3,"artifact_id"],[2,[7,"/"],[2,[6,"tags"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupHarborRepositoryArtifactTagsPath(gon.current_organization.path, ...args);
  }

  return _groupHarborRepositoryArtifactTagsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/harbor/repositories/:repository_id/artifacts(.:format)`
 * - Path helper: `group_harbor_repository_artifacts_path`
 * - URL helper: `group_harbor_repository_artifacts_url`
 * - controller#action: `groups/harbor/artifacts#index`
 *
 * @param {any} groupId
 * @param {any} repositoryId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupHarborRepositoryArtifactsPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupHarborRepositoryArtifactsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"repository_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"harbor"],[2,[7,"/"],[2,[6,"repositories"],[2,[7,"/"],[2,[3,"repository_id"],[2,[7,"/"],[2,[6,"artifacts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);
  const _groupHarborRepositoryArtifactsPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"repository_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"harbor"],[2,[7,"/"],[2,[6,"repositories"],[2,[7,"/"],[2,[3,"repository_id"],[2,[7,"/"],[2,[6,"artifacts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupHarborRepositoryArtifactsPath(gon.current_organization.path, ...args);
  }

  return _groupHarborRepositoryArtifactsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/harbor/repositories(.:format)`
 * - Path helper: `group_harbor_repositories_path`
 * - URL helper: `group_harbor_repositories_url`
 * - controller#action: `groups/harbor/repositories#index`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupHarborRepositoriesPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupHarborRepositoriesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"harbor"],[2,[7,"/"],[2,[6,"repositories"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupHarborRepositoriesPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"harbor"],[2,[7,"/"],[2,[6,"repositories"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupHarborRepositoriesPath(gon.current_organization.path, ...args);
  }

  return _groupHarborRepositoriesPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/harbor/repositories/:id(.:format)`
 * - Path helper: `group_harbor_repository_path`
 * - URL helper: `group_harbor_repository_url`
 * - controller#action: `groups/harbor/repositories#show`
 *
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupHarborRepositoryPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupHarborRepositoryPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"harbor"],[2,[7,"/"],[2,[6,"repositories"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _groupHarborRepositoryPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"harbor"],[2,[7,"/"],[2,[6,"repositories"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupHarborRepositoryPath(gon.current_organization.path, ...args);
  }

  return _groupHarborRepositoryPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/autocomplete_sources/members(.:format)`
 * - Path helper: `members_group_autocomplete_sources_path`
 * - URL helper: `members_group_autocomplete_sources_url`
 * - controller#action: `groups/autocomplete_sources#members`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const membersGroupAutocompleteSourcesPath = /*#__PURE__*/ (...args) => {
  const _membersOrganizationGroupAutocompleteSourcesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"autocomplete_sources"],[2,[7,"/"],[2,[6,"members"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _membersGroupAutocompleteSourcesPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"autocomplete_sources"],[2,[7,"/"],[2,[6,"members"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _membersOrganizationGroupAutocompleteSourcesPath(gon.current_organization.path, ...args);
  }

  return _membersGroupAutocompleteSourcesPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/autocomplete_sources/issues(.:format)`
 * - Path helper: `issues_group_autocomplete_sources_path`
 * - URL helper: `issues_group_autocomplete_sources_url`
 * - controller#action: `groups/autocomplete_sources#issues`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const issuesGroupAutocompleteSourcesPath = /*#__PURE__*/ (...args) => {
  const _issuesOrganizationGroupAutocompleteSourcesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"autocomplete_sources"],[2,[7,"/"],[2,[6,"issues"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _issuesGroupAutocompleteSourcesPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"autocomplete_sources"],[2,[7,"/"],[2,[6,"issues"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _issuesOrganizationGroupAutocompleteSourcesPath(gon.current_organization.path, ...args);
  }

  return _issuesGroupAutocompleteSourcesPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/autocomplete_sources/merge_requests(.:format)`
 * - Path helper: `merge_requests_group_autocomplete_sources_path`
 * - URL helper: `merge_requests_group_autocomplete_sources_url`
 * - controller#action: `groups/autocomplete_sources#merge_requests`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mergeRequestsGroupAutocompleteSourcesPath = /*#__PURE__*/ (...args) => {
  const _mergeRequestsOrganizationGroupAutocompleteSourcesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"autocomplete_sources"],[2,[7,"/"],[2,[6,"merge_requests"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _mergeRequestsGroupAutocompleteSourcesPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"autocomplete_sources"],[2,[7,"/"],[2,[6,"merge_requests"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _mergeRequestsOrganizationGroupAutocompleteSourcesPath(gon.current_organization.path, ...args);
  }

  return _mergeRequestsGroupAutocompleteSourcesPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/autocomplete_sources/labels(.:format)`
 * - Path helper: `labels_group_autocomplete_sources_path`
 * - URL helper: `labels_group_autocomplete_sources_url`
 * - controller#action: `groups/autocomplete_sources#labels`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const labelsGroupAutocompleteSourcesPath = /*#__PURE__*/ (...args) => {
  const _labelsOrganizationGroupAutocompleteSourcesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"autocomplete_sources"],[2,[7,"/"],[2,[6,"labels"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _labelsGroupAutocompleteSourcesPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"autocomplete_sources"],[2,[7,"/"],[2,[6,"labels"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _labelsOrganizationGroupAutocompleteSourcesPath(gon.current_organization.path, ...args);
  }

  return _labelsGroupAutocompleteSourcesPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/autocomplete_sources/commands(.:format)`
 * - Path helper: `commands_group_autocomplete_sources_path`
 * - URL helper: `commands_group_autocomplete_sources_url`
 * - controller#action: `groups/autocomplete_sources#commands`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const commandsGroupAutocompleteSourcesPath = /*#__PURE__*/ (...args) => {
  const _commandsOrganizationGroupAutocompleteSourcesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"autocomplete_sources"],[2,[7,"/"],[2,[6,"commands"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _commandsGroupAutocompleteSourcesPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"autocomplete_sources"],[2,[7,"/"],[2,[6,"commands"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _commandsOrganizationGroupAutocompleteSourcesPath(gon.current_organization.path, ...args);
  }

  return _commandsGroupAutocompleteSourcesPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/autocomplete_sources/milestones(.:format)`
 * - Path helper: `milestones_group_autocomplete_sources_path`
 * - URL helper: `milestones_group_autocomplete_sources_url`
 * - controller#action: `groups/autocomplete_sources#milestones`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const milestonesGroupAutocompleteSourcesPath = /*#__PURE__*/ (...args) => {
  const _milestonesOrganizationGroupAutocompleteSourcesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"autocomplete_sources"],[2,[7,"/"],[2,[6,"milestones"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _milestonesGroupAutocompleteSourcesPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"autocomplete_sources"],[2,[7,"/"],[2,[6,"milestones"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _milestonesOrganizationGroupAutocompleteSourcesPath(gon.current_organization.path, ...args);
  }

  return _milestonesGroupAutocompleteSourcesPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/crm/contacts(.:format)`
 * - Path helper: `group_crm_contacts_path`
 * - URL helper: `group_crm_contacts_url`
 * - controller#action: `groups/crm/contacts#index`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupCrmContactsPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupCrmContactsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"crm"],[2,[7,"/"],[2,[6,"contacts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupCrmContactsPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"crm"],[2,[7,"/"],[2,[6,"contacts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupCrmContactsPath(gon.current_organization.path, ...args);
  }

  return _groupCrmContactsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/crm/contacts/new(.:format)`
 * - Path helper: `new_group_crm_contact_path`
 * - URL helper: `new_group_crm_contact_url`
 * - controller#action: `groups/crm/contacts#new`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newGroupCrmContactPath = /*#__PURE__*/ (...args) => {
  const _newOrganizationGroupCrmContactPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"crm"],[2,[7,"/"],[2,[6,"contacts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _newGroupCrmContactPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"crm"],[2,[7,"/"],[2,[6,"contacts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _newOrganizationGroupCrmContactPath(gon.current_organization.path, ...args);
  }

  return _newGroupCrmContactPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/crm/contacts/:id/edit(.:format)`
 * - Path helper: `edit_group_crm_contact_path`
 * - URL helper: `edit_group_crm_contact_url`
 * - controller#action: `groups/crm/contacts#edit`
 *
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editGroupCrmContactPath = /*#__PURE__*/ (...args) => {
  const _editOrganizationGroupCrmContactPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"crm"],[2,[7,"/"],[2,[6,"contacts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);
  const _editGroupCrmContactPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"crm"],[2,[7,"/"],[2,[6,"contacts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _editOrganizationGroupCrmContactPath(gon.current_organization.path, ...args);
  }

  return _editGroupCrmContactPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/crm/organizations(.:format)`
 * - Path helper: `group_crm_organizations_path`
 * - URL helper: `group_crm_organizations_url`
 * - controller#action: `groups/crm/organizations#index`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupCrmOrganizationsPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupCrmOrganizationsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"crm"],[2,[7,"/"],[2,[6,"organizations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupCrmOrganizationsPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"crm"],[2,[7,"/"],[2,[6,"organizations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupCrmOrganizationsPath(gon.current_organization.path, ...args);
  }

  return _groupCrmOrganizationsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/crm/organizations/new(.:format)`
 * - Path helper: `new_group_crm_organization_path`
 * - URL helper: `new_group_crm_organization_url`
 * - controller#action: `groups/crm/organizations#new`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newGroupCrmOrganizationPath = /*#__PURE__*/ (...args) => {
  const _newOrganizationGroupCrmOrganizationPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"crm"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _newGroupCrmOrganizationPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"crm"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _newOrganizationGroupCrmOrganizationPath(gon.current_organization.path, ...args);
  }

  return _newGroupCrmOrganizationPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/crm/organizations/:id/edit(.:format)`
 * - Path helper: `edit_group_crm_organization_path`
 * - URL helper: `edit_group_crm_organization_url`
 * - controller#action: `groups/crm/organizations#edit`
 *
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editGroupCrmOrganizationPath = /*#__PURE__*/ (...args) => {
  const _editOrganizationGroupCrmOrganizationPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"crm"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);
  const _editGroupCrmOrganizationPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"crm"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _editOrganizationGroupCrmOrganizationPath(gon.current_organization.path, ...args);
  }

  return _editGroupCrmOrganizationPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/achievements(.:format)`
 * - Path helper: `group_achievements_path`
 * - URL helper: `group_achievements_url`
 * - controller#action: `groups/achievements#index`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupAchievementsPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupAchievementsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"achievements"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _groupAchievementsPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"achievements"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupAchievementsPath(gon.current_organization.path, ...args);
  }

  return _groupAchievementsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/achievements/new(.:format)`
 * - Path helper: `new_group_achievement_path`
 * - URL helper: `new_group_achievement_url`
 * - controller#action: `groups/achievements#new`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newGroupAchievementPath = /*#__PURE__*/ (...args) => {
  const _newOrganizationGroupAchievementPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"achievements"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _newGroupAchievementPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"achievements"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _newOrganizationGroupAchievementPath(gon.current_organization.path, ...args);
  }

  return _newGroupAchievementPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/achievements/:id/edit(.:format)`
 * - Path helper: `edit_group_achievement_path`
 * - URL helper: `edit_group_achievement_url`
 * - controller#action: `groups/achievements#edit`
 *
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editGroupAchievementPath = /*#__PURE__*/ (...args) => {
  const _editOrganizationGroupAchievementPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"achievements"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _editGroupAchievementPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"achievements"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _editOrganizationGroupAchievementPath(gon.current_organization.path, ...args);
  }

  return _editGroupAchievementPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/work_items/:iid(.:format)`
 * - Path helper: `group_work_item_path`
 * - URL helper: `group_work_item_url`
 * - controller#action: `groups/work_items#show`
 *
 * @param {any} groupId
 * @param {any} iid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupWorkItemPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupWorkItemPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"iid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"work_items"],[2,[7,"/"],[2,[3,"iid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupWorkItemPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"iid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"work_items"],[2,[7,"/"],[2,[3,"iid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupWorkItemPath(gon.current_organization.path, ...args);
  }

  return _groupWorkItemPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/work_items/new`
 * - Path helper: `group_work_item_new_path`
 * - URL helper: `group_work_item_new_url`
 * - controller#action: `groups/work_items#show`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupWorkItemNewPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupWorkItemNewPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"work_items"],[2,[7,"/"],[6,"new"]]]]]]]]]]]]]]);
  const _groupWorkItemNewPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"work_items"],[2,[7,"/"],[6,"new"]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupWorkItemNewPath(gon.current_organization.path, ...args);
  }

  return _groupWorkItemNewPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/import_history(.:format)`
 * - Path helper: `group_import_history_path`
 * - URL helper: `group_import_history_url`
 * - controller#action: `groups/import_histories#show`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupImportHistoryPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupImportHistoryPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"import_history"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _groupImportHistoryPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"import_history"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupImportHistoryPath(gon.current_organization.path, ...args);
  }

  return _groupImportHistoryPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/observability/o11y_service_settings/edit(.:format)`
 * - Path helper: `edit_group_observability_o11y_service_settings_path`
 * - URL helper: `edit_group_observability_o11y_service_settings_url`
 * - controller#action: `groups/observability/o11y_service_settings#edit`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editGroupObservabilityO11yServiceSettingsPath = /*#__PURE__*/ (...args) => {
  const _editOrganizationGroupObservabilityO11yServiceSettingsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"observability"],[2,[7,"/"],[2,[6,"o11y_service_settings"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);
  const _editGroupObservabilityO11yServiceSettingsPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"observability"],[2,[7,"/"],[2,[6,"o11y_service_settings"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _editOrganizationGroupObservabilityO11yServiceSettingsPath(gon.current_organization.path, ...args);
  }

  return _editGroupObservabilityO11yServiceSettingsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/observability/o11y_service_settings(.:format)`
 * - Path helper: `group_observability_o11y_service_settings_path`
 * - URL helper: `group_observability_o11y_service_settings_url`
 * - controller#action: `groups/observability/o11y_service_settings#update`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupObservabilityO11yServiceSettingsPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupObservabilityO11yServiceSettingsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"observability"],[2,[7,"/"],[2,[6,"o11y_service_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupObservabilityO11yServiceSettingsPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"observability"],[2,[7,"/"],[2,[6,"o11y_service_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupObservabilityO11yServiceSettingsPath(gon.current_organization.path, ...args);
  }

  return _groupObservabilityO11yServiceSettingsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/observability/setup(.:format)`
 * - Path helper: `group_observability_setup_path`
 * - URL helper: `group_observability_setup_url`
 * - controller#action: `groups/observability/setup#show`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupObservabilitySetupPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupObservabilitySetupPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"observability"],[2,[7,"/"],[2,[6,"setup"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupObservabilitySetupPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"observability"],[2,[7,"/"],[2,[6,"setup"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupObservabilitySetupPath(gon.current_organization.path, ...args);
  }

  return _groupObservabilitySetupPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/observability/access_requests(.:format)`
 * - Path helper: `group_observability_access_requests_path`
 * - URL helper: `group_observability_access_requests_url`
 * - controller#action: `groups/observability/access_requests#create`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupObservabilityAccessRequestsPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupObservabilityAccessRequestsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"observability"],[2,[7,"/"],[2,[6,"access_requests"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _groupObservabilityAccessRequestsPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"observability"],[2,[7,"/"],[2,[6,"access_requests"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupObservabilityAccessRequestsPath(gon.current_organization.path, ...args);
  }

  return _groupObservabilityAccessRequestsPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/observability/:id`
 * - Path helper: `group_observability_path`
 * - URL helper: `group_observability_url`
 * - controller#action: `groups/observability#show`
 *
 * @param {any} groupId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupObservabilityPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupObservabilityPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"observability"],[2,[7,"/"],[3,"id"]]]]]]]]]]]]]]);
  const _groupObservabilityPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"id":{"r":true}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"observability"],[2,[7,"/"],[3,"id"]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupObservabilityPath(gon.current_organization.path, ...args);
  }

  return _groupObservabilityPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/observability/*sub_path`
 * - Path helper: `group_observability_sub_path_path`
 * - URL helper: `group_observability_sub_path_url`
 * - controller#action: `groups/observability#show`
 *
 * @param {any} groupId
 * @param {any} subPath
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupObservabilitySubPathPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupObservabilitySubPathPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"sub_path":{"r":true}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"observability"],[2,[7,"/"],[5,[3,"sub_path"]]]]]]]]]]]]]]]);
  const _groupObservabilitySubPathPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"sub_path":{"r":true}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"observability"],[2,[7,"/"],[5,[3,"sub_path"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupObservabilitySubPathPath(gon.current_organization.path, ...args);
  }

  return _groupObservabilitySubPathPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/step_up_auths/new(.:format)`
 * - Path helper: `new_group_step_up_auth_path`
 * - URL helper: `new_group_step_up_auth_url`
 * - controller#action: `groups/step_up_auths#new`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newGroupStepUpAuthPath = /*#__PURE__*/ (...args) => {
  const _newOrganizationGroupStepUpAuthPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"step_up_auths"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);
  const _newGroupStepUpAuthPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"step_up_auths"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _newOrganizationGroupStepUpAuthPath(gon.current_organization.path, ...args);
  }

  return _newGroupStepUpAuthPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/preview_markdown(.:format)`
 * - Path helper: `group_preview_markdown_path`
 * - URL helper: `group_preview_markdown_url`
 * - controller#action: `groups#preview_markdown`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupPreviewMarkdownPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupPreviewMarkdownPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"preview_markdown"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _groupPreviewMarkdownPath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"preview_markdown"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupPreviewMarkdownPath(gon.current_organization.path, ...args);
  }

  return _groupPreviewMarkdownPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/groups/*group_id/-/restore(.:format)`
 * - Path helper: `group_restore_path`
 * - URL helper: `group_restore_url`
 * - controller#action: `groups#restore`
 *
 * @param {any} groupId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupRestorePath = /*#__PURE__*/ (...args) => {
  const _organizationGroupRestorePath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"restore"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _groupRestorePath = /*#__PURE__*/ __jsr.r({"group_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"groups"],[2,[7,"/"],[2,[5,[3,"group_id"]],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"restore"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupRestorePath(gon.current_organization.path, ...args);
  }

  return _groupRestorePath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/*id(.:format)`
 * - Path helper: `group_path`
 * - URL helper: `group_url`
 * - controller#action: `groups#show`
 *
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const groupPath = /*#__PURE__*/ (...args) => {
  const _organizationGroupPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[5,[3,"id"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]);
  const _groupPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"id"]],[1,[2,[8,"."],[3,"format"]]]]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationGroupPath(gon.current_organization.path, ...args);
  }

  return _groupPath(...args);
};

/**
 * Generates the Rails route:
 *
 * - href: `/v2`
 * - Path helper: `v2_path`
 * - URL helper: `v2_url`
 * - controller#action: `groups/dependency_proxy_auth#authenticate`
 *
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const v2Path = /*#__PURE__*/ (...args) => {
  const _organizationV2Path = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[6,"v2"]]]]]]);
  const _v2Path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[6,"v2"]]);

  if (hasOrganizationScopedPaths()) {
    return _organizationV2Path(gon.current_organization.path, ...args);
  }

  return _v2Path(...args);
};

